<div class="ng-container">
    <div class="ng-content">
        <div class="ng-title">{{ messages.latestPrices }}</div>
        <div class="ng-description">
            {{ messages.updateResults }}
        </div>
        <button class="ng-research-btn"
                (click)="repeatSearch()">
                {{ messages.refreshSearch }}
        </button>
    </div>
</div>